import _ from 'underscore';

import { LabelValueContentItem } from '~src/catalog/restApi/labels/LabelValueTypes';
import { ReactActionDialogBodyProps, ReactActionDialogOptions } from '~src/commonInfra/dialogs/ReactActionDialog';

import { Messages } from '../../../codegen/Localize';
import { SubmitLabelCommand } from '../labels/canSubmitLabel';

export const DESCRIPTION_MAXIMUM_LENGTH: number = 500;
export const CERTIFICATION_LABEL_VALUE_DIALOG_MESSAGE_ID: string = 'Certification-label-value-dialog-message';
export const CERTIFICATION_LABEL_VALUE_HELP_TEST_ID: string = 'Certification-label-value-help';
export type LabelValueDialogState = {
    readonly labelValueName: string;
    readonly category: string;
    readonly description: string;
    readonly elevatedDefault: boolean;
  }

export type LabelValueDialogBodyProps = {
    readonly contentItem: LabelValueContentItem;
    readonly showLabelManagementLink?: boolean;
    readonly messageOptional?: boolean;
    readonly allowsMulti?: boolean;
}

export type DialogType = 'certification' | 'warning' | 'sensitivity';

export function defaultLabelValueInitialState(category: string, name: string): LabelValueDialogState {
return {
    labelValueName: name,
    category: category,
    description: '',
    elevatedDefault: false,
};
}

export type LabelValueActionDialogOptions = ReactActionDialogOptions<LabelValueDialogBodyProps, LabelValueDialogState, unknown>;
export type LabelValueDialogBodyComponentProps = ReactActionDialogBodyProps<LabelValueDialogBodyProps, LabelValueDialogState>;

export function checkIsValid(current: LabelValueDialogState): boolean {
    const command = canSubmitLabelValue({ description: current.description});
    return command === 'SUBMIT';
}


function canSubmitLabelValue(params:
    { description: string}): SubmitLabelCommand {
    const { description } = params;

    if (description.length > DESCRIPTION_MAXIMUM_LENGTH) {
        return 'TOOLONG';
    }
    if (_.isEmpty(description.trim())) {
        return 'NOMESSAGE';
    }

    return 'SUBMIT';
}

export function getLabelValueDialogTitle(labelValueName: string): string {

  switch (labelValueName) {
    case 'CERTIFIED':
      return Messages.certificationLabelValueTitle();
    case 'EXTRACT_REFRESH_FAILURE':
      return Messages.editExtractRefreshMonitoringLabel();
    case 'FLOW_RUN_FAILURE':
      return Messages.editFlowRunMonitoringLabel();
    default: {
      throw Error('This Label value name is not supported.');
    }
  }
}